import Swal from "sweetalert2";

// CITAS-FINALIZED-UX-01: unica fuente de verdad en frontend para detectar el
// 409 "cita finalizada" que YA responde el backend (back_smartmedic:
// src/function/FCitaEstado.ts). No se toca la politica backend -- este
// modulo solo reacciona a ella.
export const CITA_ESTADO_FINALIZADA = 6; // citas.id_estado_cita = 6 ("Finalizada")

// FIX-49 §9: identidad estable de los estados que participan en el flujo de
// consulta. Antes la UI decidia comparando el TEXTO del estado
// (`estado === "En Consulta"`), asi que renombrar una fila del catalogo
// `estado_citas` habria roto el flujo en silencio.
export const CITA_ESTADO_SALA_ESPERA = 3; // "En sala de espera"
export const CITA_ESTADO_EN_CONSULTA = 5; // "En Consulta"

/** id de estado de una cita, venga como venga en la respuesta. */
export function getIdEstadoCita(cita) {
  const idestado =
    cita?.id_estado_cita ??
    cita?.idestado_cita ??
    cita?.estado_cita?.idestado_cita;
  return idestado === undefined || idestado === null || idestado === "" ? null : Number(idestado);
}

export const CITA_FINALIZADA_MESSAGE =
  "La cita está finalizada y ya no puede modificarse.";
export const CITA_NO_REABRE_MESSAGE =
  "La cita está finalizada y no puede reabrirse.";

const READ_ONLY_MESSAGES = new Set([CITA_FINALIZADA_MESSAGE, CITA_NO_REABRE_MESSAGE]);

// FIX-50: mensajes de 409 que NO son "solo lectura" sino "transicion de estado
// no permitida". Sin registrarlos aqui, el 409 llegaba a `Controllerenfermendad`
// -> catch -> `return null` -> el componente no mostraba NADA (fallo silencioso).
// Texto y politica los sigue decidiendo el backend; esto solo lo hace visible.
export const CITA_NO_INICIA_CONSULTA_MESSAGE =
  "La cita no puede pasar a consulta en su estado actual.";
export const CITA_NO_MUTABLE_MESSAGE =
  "La cita no admite modificaciones en su estado actual.";
// CONSULTA-ABIERTA: 409 que devuelve `guardConsultaAbierta` en el backend
// cuando el medico intenta escribir sin haber abierto la consulta. Texto
// EXACTO de MENSAJE_CONSULTA_NO_ABIERTA -- si cambia alla, cambia aqui.
export const CONSULTA_NO_ABIERTA_MESSAGE =
  "Para registrar datos clínicos primero debes iniciar la consulta.";

const TRANSICION_INVALIDA_MESSAGES = new Set([
  CITA_NO_INICIA_CONSULTA_MESSAGE,
  CITA_NO_MUTABLE_MESSAGE,
  CONSULTA_NO_ABIERTA_MESSAGE,
]);

// Valor centinela que los Service.*.js pueden devolver cuando ya mostraron el
// aviso de "cita finalizada" -- permite que el componente que llamo omita su
// propio mensaje de error generico, evitando mostrar dos avisos a la vez
// (uno especifico + uno generico) para el mismo fallo.
export const CITA_FINALIZADA_SENTINEL = "__CITA_FINALIZADA__";

/**
 * Detecta si un error de axios corresponde EXACTAMENTE al 409 de cita
 * finalizada del backend y, si es asi, muestra un aviso NO bloqueante
 * (SweetAlert2 en modo `toast` -- misma libreria ya usada en toda la app,
 * en un modo ya utilizado en otras pantallas del sistema; no es un segundo
 * sistema de alertas). No intercepta ningun otro error 409 ni de ningun
 * otro tipo -- el resto de manejo de errores del sistema queda intacto.
 *
 * Devuelve true si mostro el aviso (el llamador puede omitir su propio
 * manejo de error generico para esa misma falla).
 */
export function notifyCitaFinalizada(error) {
  const status = error?.response?.status;
  const message = error?.response?.data?.message;
  if (status === 409 && READ_ONLY_MESSAGES.has(message)) {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "warning",
      title: "Consulta finalizada",
      text: "Esta consulta es de solo lectura. La información clínica ya no puede modificarse.",
      showConfirmButton: false,
      timer: 4500,
      timerProgressBar: true,
    });
    return true;
  }
  if (status === 409 && TRANSICION_INVALIDA_MESSAGES.has(message)) {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "warning",
      title: "Estado de la cita",
      text: message,
      showConfirmButton: false,
      timer: 4500,
      timerProgressBar: true,
    });
    return true;
  }
  return false;
}

/**
 * true si el objeto de cita (en cualquiera de las formas que devuelven hoy
 * los distintos endpoints: `citas` crudo, `{estado_cita:{...}}`, etc.) esta
 * en el estado terminal "Finalizada". Solo lectura -- no decide nada por si
 * mismo, el backend sigue siendo la autoridad (409 en cada escritura).
 */
export function isCitaFinalizada(cita) {
  if (!cita) return false;
  const idestado =
    cita.id_estado_cita ??
    cita.idestado_cita ??
    cita.estado_cita?.idestado_cita;
  if (idestado !== undefined && idestado !== null && idestado !== "") {
    return Number(idestado) === CITA_ESTADO_FINALIZADA;
  }
  // Fallback por nombre, para respuestas que solo traen el string del estado.
  return cita.estado_cita?.estado === "Finalizada" || cita.estado === "Finalizada";
}
